import styled, {css} from 'styled-components';

interface ItemProps {
  readonly bColor?: string;
}

export const FiltersContainer = styled.section<ItemProps>`
  background-color: var(--BackgroundLighter);

  ${props => {
    const color = `background-color: ${props.bColor}`;

    return css`
       {
        ${color}
      }
    `;
  }};
`;
